import React from 'react'
import { Box } from '../Core'
import { Swiper, SwiperSlide } from 'swiper/react'

import SwiperCore, { Pagination, Autoplay, Navigation } from 'swiper'

import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'

// install Swiper modules
SwiperCore.use([Pagination, Autoplay, Navigation])

const Slides = ({ children }) => {
    const breakpoints = {
        '640': {
            slidesPerView: 1,
            spaceBetween: 20
        },
        '960': {
            slidesPerView: 1,
            spaceBetween: 20
        },
        '1400': {
            slidesPerView: 1,
            spaceBetween: 20
        }
    }

    return (
        <Box
            borderRadius="2rem"
            css={`
                overflow: hidden;
                box-shadow: 0px 0px 42px 11px rgba(0, 0, 0, 0.1);
            `}
        >
            <Swiper
                slidesPerView={1}
                spaceBetween={10}
                pagination={{
                    clickable: true,
                    horizontalClass: 'swiper-custom-pagination'
                }}
                navigation={{}}
                breakpoints={breakpoints}
                autoplay={{ delay: 5000 }}
            >
                {React.Children.map(children, child => (
                    <SwiperSlide>{React.cloneElement(child)}</SwiperSlide>
                ))}
            </Swiper>
        </Box>
    )
}

export default Slides
